import React, { useMemo, useState } from "react";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import Badge from "./BadgeDisciplinary";
import { SvgBlackTrash, SvgMenuExpenses, SvgUpdateAssignationIcon } from "@routes/IconeSvg";
import file_carrer from "@assets/image/icones/carrer/file_carrer.svg";
import notif_certification from "@assets/image/icones/carrer/notif_certification.svg";
import moment from "moment-timezone";
import SharedViewFile from "@components/modals/SharedViewFile";
import { Menu } from "@components/tailwindComponents";
import useDisciplinary from "./helpers/_functions";
import ModalDelete from "./DeleteDisciplinary";

const DisciplinaryItemTable = (props) => {
  const { 
    disciplinary, 
    translator, 
    i18n, 
    readOnly,
    toggleModalDisciplinaryForm
  } = props;
  const [showDelete, setShowDelete] = useState(false);
  const [sharedViewFile, setShowFile] = useState(false);
  const [file, setFile] = useState({});
  const { deleteDisciplinary } = useDisciplinary();

  const disciplinaryStyles = useMemo(() => ({
    Event: {
      bgColorStatus: "arh-bg-[#E2F1FE]",
      bgCircleStatus: "arh-bg-[#265985]",
      textColorStatus: "arh-text-[#265985]",
      titleEvent: translator("Événement"),
    },
    Communication: {
      bgColorStatus: "arh-bg-[#FBEED6]",
      bgCircleStatus: "arh-bg-[#F29D0E]",
      textColorStatus: "arh-text-[#F29D0E]",
      titleEvent: translator("Communication"),
    },
    Sanction: {
      bgColorStatus: "arh-bg-[#F9E6DD]",
      bgCircleStatus: "arh-bg-[#C24E27]",
      textColorStatus: "arh-text-[#C24E27]",
      titleEvent: translator("Sanction"),
    },
  }), []);

  const disciplinaryStyle = useMemo(() => (
    disciplinaryStyles[disciplinary?.typeEvent]
  ), [disciplinary?.typeEvent, disciplinaryStyles]);

  const onClickDelete = () => {
    setShowDelete(!showDelete);
  };

  const onClickShowFile = (file) => {
    setShowFile(!sharedViewFile);
    setFile(file);
  };

  const handleDeleteDisciplinary  = () => {
    deleteDisciplinary(disciplinary?._id, () => {
      onClickDelete();
    })
  }

    const listsMenu = [
      {
        icon: <SvgBlackTrash />,
        title: translator("Effacer"),
        click: () => onClickDelete()
      },
      {
        icon: <SvgUpdateAssignationIcon />,
        title: translator("Modifier"),
        click: () => toggleModalDisciplinaryForm(disciplinary)
      }
    ]

  const periodDisciplinary = moment(disciplinary.startDate)
    .locale(i18n.language)
    .format("LL"
    )
    + (moment(disciplinary.endDate).isValid()
      ? ` - ${moment(disciplinary.endDate)
        .locale(i18n.language)
        .format("LL"
        )}`
      : "");
  return (
    <>
      <tr className={"arh-border arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-greyBorderInput arh-px-5 arh-text-xs hover:arh-bg-greyColor"}>
        
        <td
          className={`arh-px-5 arh-py-3 arh-text-xs ${!readOnly ? "arh-cursor-pointer" : ""}`}
          onClick={!readOnly ? () => toggleModalDisciplinaryForm(disciplinary) : undefined}
        >
              <BlackTooltip
                title={<p
                  className="arh-m-0 arh-w-full"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 5,
                    fontSize: "12px"
                  }}
                >
                  {disciplinary?.title}
                </p>}
                placement="top"
              >
                <div className="arh-w-full arh-truncate">
                  {disciplinary?.title || "-"}
                </div>
              </BlackTooltip>
            </td>
        
        <td className="arh-px-5 arh-py-3 arh-text-xs ">
          <Badge
            bgColorStatus={disciplinaryStyle.bgColorStatus}
            bgCircleStatus={disciplinaryStyle.bgCircleStatus}
            textColorStatus={disciplinaryStyle.textColorStatus}
            titleEvent={disciplinaryStyle.titleEvent}
          />
        </td>
        <td
          className="arh-px-5 arh-py-3 arh-text-xs "
        >
          {disciplinary?.category?.name || "-"}
        </td>
        <td
          className="arh-px-5 arh-py-3 arh-text-xs "
        >
          {disciplinary?.gradation?.name || "-"}
        </td>
        <td className="arh-px-5 arh-py-3 arh-text-xs ">
          <BlackTooltip title={periodDisciplinary} placement="top">
            <div className="arh-block arh-w-full arh-truncate">
              {periodDisciplinary}
            </div>
          </BlackTooltip>
        </td>

        {/* Disparaisse en Myprofile */}
        {!readOnly ?
          <>
            <td className="arh-px-5 arh-py-3 arh-text-xs ">
              {disciplinary?.notes ? (
                <BlackTooltip
                  title={
                    <p
                      className="arh-m-0 arh-w-full"
                      style={{
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 10,
                        fontSize: "12px"
                      }}
                    >
                      {disciplinary.notes}
                    </p>
                  }
                  placement="top"
                >
                  <img alt="file_carrer" src={file_carrer} />
                </BlackTooltip>
              ) : (
                "-"
              )}
            </td>
            <td className="arh-px-5 arh-py-3 arh-text-xs ">
              {disciplinary?.files?.length > 0
                ? disciplinary?.files?.map((file) => (
                  <BlackTooltip
                    title={file?.filename}
                    placement="top"
                    key={file?._id}
                  >
                    <div
                      className="arh-flex arh-items-center arh-justify-start arh-space-x-2 arh-w-full arh-cursor-pointer"
                      onClick={() => onClickShowFile(file)}
                    >
                      <span>{SvgMenuExpenses()}</span>
                      <span className="arh-block arh-w-full arh-truncate arh-underline">
                        {file?.filename}
                      </span>
                    </div>
                  </BlackTooltip>
                ))
                : "-"}
            </td>
            <td className="arh-px-5 arh-py-3 arh-text-xs ">
              {disciplinary?.alertDate && moment(disciplinary.alertDate).isValid() ? (
                <BlackTooltip
                  title={moment(disciplinary.alertDate)
                    .locale(i18n.language)
                    .format("LL")}
                  placement="top"
                >
                  <div className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-start arh-space-x-2">
                    <span>
                      <img alt="notif_certification" src={notif_certification} />
                    </span>
                    <span className="arh-block arh-w-full arh-truncate">
                      {moment(disciplinary.alertDate)
                        .locale(i18n.language)
                        .format("LL")}
                    </span>
                  </div>
                </BlackTooltip>
              ) : (
              "-"
              )}
            </td>
          </> : " "
        }
        
        
          {!readOnly ?
            <td className="arh-px-4 arh-py-3 ">
              <Menu
                lists={listsMenu}
                withIcon
              />
            </td>
            : ""
          }
        
      </tr>
      <ModalDelete
        onClickClose={onClickDelete}
        onDeleteClick={handleDeleteDisciplinary }
        show={showDelete}
        t={translator}
      />
      <SharedViewFile
        onClickClose={onClickShowFile}
        show={sharedViewFile}
        file={file}
        t={translator}
      />
    </>
  );
};

export default DisciplinaryItemTable;
